export const paymentConfig = {
    public_key: 'FLWPUBK_TEST-a4b281ea230badb1ca0a92ac863e23d1-X',
    tx_ref: Date.now(),
    amount: 5000,
    currency: 'UGX',
    payment_options: 'card,mobilemoney,ussd',
    customer: {
      email: 'user@gmail.com',
      phonenumber: '08102909304',
      name: 'yemi desola',
    },
    customizations: {
      title: 'Child Hope International  Foundation',
      description: 'Donations to the Foundation',
      logo: 'https://cdn.filestackcontent.com/ie5vDpMCTDyPBmJalMfs',
    },
  };